/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import * as styles from './Heading.scss'

const cx = classNames.bind(styles)

const tags = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
]

type StyleType = 'brandColor' | 'lightColor' | 'subHeader'

interface IProps {
  size?: number,
  children?: React.ReactChildren,
  title?: string,
  styleType?: StyleType,
}

const Heading: React.SFC<IProps> = ({
  size = 2,
  children,
  title = children,
  styleType = 'default',
}) => {
  const Tag = tags[size - 1]
  return title
    ? (<Tag className={cx('root', Tag, styleType)}>{title}</Tag>)
    : null
}

export default Heading
